import type { KeyboardEvent } from 'react';

import { goToPage } from '../TopAreaBanner/components/TopAreaBannerContent/goToPage';

export const onEnterPressHandler = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key === 'Enter') {
    const { value: searchQuery } = e.currentTarget;
    goToPage(`/search?query=${encodeURIComponent(searchQuery)}`);
  }
};
